module.exports = __webpack_public_path__ + "img/symbol_1.3d4a1f92.png";